const createSyncValidator = (...fieldsValidators) => values => {
  let newFieldsValidators

  // TODO: @rastym - should move that condtitional validators block outside of the createSyncValidators
  // start of validaton block.probably should be moved to - src/app/validators/activities/create/index
  const valuesToValidate = values.toJS ? values.toJS() : values
  const videoValidator = fieldsValidators.find(validator => validator.field === 'videoThumbnail')?.validator
  const imageValidator = fieldsValidators.find(validator => validator.field === 'image')?.validator
  let isImageValid
  let isVideoValid

  if (imageValidator) {
    isImageValid = !imageValidator(valuesToValidate.image)
  }
  if (videoValidator) {
    isVideoValid = !imageValidator(valuesToValidate.videoThumbnail)
  }

  if (isImageValid && !isVideoValid) {
    newFieldsValidators = fieldsValidators.filter(({ field }) => field !== 'videoThumbnail')
  } else if (!isImageValid && isVideoValid) {
    newFieldsValidators = fieldsValidators.filter(({ field }) => field !== 'image')
  } else {
    newFieldsValidators = fieldsValidators
  }
  // end of validaton block.probably should be moved to - src/app/validators/activities/create/index

  const errors = newFieldsValidators.reduce((acc, { field, validator }) => {
    const value = values.get ? values.get(field) : values[field]
    const error = validator(value, values)
    if (Array.isArray(error)) {
      return {
        ...acc,
        [field]: error,
      }
    }
    return {
      ...acc,
      ...error,
    }
  }, {})
  if (Object.keys(errors).length) {
    return errors
  }
}

export default createSyncValidator
